import React, { useEffect, useState } from 'react';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

import { Bloc, Button } from 'design-system';
import Icon from '@mdi/react';
import { Comments, CommentCount } from '@hyvor/hyvor-talk-react';
import { CommentCounts } from '@hyvor/hyvor-talk-base';
import { mdiClose } from '@mdi/js';
import { useQuery } from 'hooks';
import { GQL_GET_COMMENTS_AUTH } from 'gql/getCommentAuth';
import { Mask } from 'UI';
import { CustomErrorBoundary } from 'utils';
import './Comments.scss';

const Commentaries = ({ chapter }) => {
  const [displayCommentsModal, setCommentsModal] = useState(false);
  const toggleCommentsModal = () => setCommentsModal(!displayCommentsModal);
  const { data, loading } = useQuery(GQL_GET_COMMENTS_AUTH);

  if (displayCommentsModal) {
    disableBodyScroll();
  }

  const loadComments = () => {
    CommentCounts.load({
      'website-id': process.env.REACT_APP_HYVORTALK_WEBSITE_ID,
    });
  };

  useEffect(() => {
    if (!loading) loadComments();
  }, [chapter._id, loading]);

  if (loading) return null;

  return (
    <div className="comments">
      <Button
        variant="primary"
        label={<CommentCount page-id={chapter._id} />}
        onClick={toggleCommentsModal}
      />
      {displayCommentsModal && (
        <Mask
          className="comments-mask"
          onClose={() => {
            loadComments();
            setCommentsModal(false);
            clearAllBodyScrollLocks();
          }}
          withOverlay
        >
          <div className="comments-modal">
            <Bloc
              className="comments-bloc"
              title="Commentaires"
              title_right={
                <span id="icon-comments-modal">
                  <Icon
                    onClick={() => {
                      loadComments();
                      setCommentsModal(false);
                      clearAllBodyScrollLocks();
                    }}
                    path={mdiClose}
                  />
                </span>
              }
            >
              <Comments
                website-id={process.env.REACT_APP_HYVORTALK_WEBSITE_ID}
                page-id={chapter._id}
                sso-hash={data?.me.commentsAuth.hash}
                sso-user={data?.me.commentsAuth.user}
              />
            </Bloc>
          </div>
        </Mask>
      )}
    </div>
  );
};

function CommentsError() {
  return null;
}
export default function CommentsWrapper(props) {
  return (
    <CustomErrorBoundary handleError={<CommentsError />}>
      <Commentaries {...props} />
    </CustomErrorBoundary>
  );
}
